module.exports = __webpack_public_path__ + "static/media/IMG_3671.505b044f.jpg";